module.exports = __webpack_public_path__ + "img/20220822.253666c6.png";